<template>
    <div class="item-type-document">
        <template v-if="pdfViewerEnabled && item.canView && item.isPdf">
            <object v-if="item.url" :data="`${item.url}.pdf/${item.file_id}`" type="application/pdf">
                <embed :src="`${item.url}.pdf/${item.file_id}`" type="application/pdf"/>
                <document-fallback :item="item" />
            </object>
        </template>
        <template v-if="googleViewerEnabled && item.isWord">
            <iframe :src="`https://docs.google.com/gview?url=${item.url}.doc/${item.file_id}&embedded=true`"></iframe>
        </template>
        <template v-else>
            <document-fallback :item="item" />
        </template>
    </div>
</template>

<script>
import DocumentFallback from './DocumentFallback';

export default {
    name: 'Document',
    components: {
        DocumentFallback,
    },
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    computed: {
        pdfViewerEnabled() {
            return ca.config('media.integrations.pdf_viewer.enabled');
        },
        googleViewerEnabled() {
             return ca.config('media.integrations.google_viewer.enabled');
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~/sass/_variables';

.item-type-document {

    object, iframe {
        width: 100%;
        height: 100%;
    }

    height: 100%; //calc(100vh - 121px);
    width: 100%;
}
</style>
